import React from 'react';
import PropTypes from 'prop-types';
import styled from 'fe-styled-components';
import theme, { rems } from 'fe-appdir-lib-theme';

const PROP_TYPES = {
  graphic: PropTypes.func,
  heading: PropTypes.string.isRequired,
  body: PropTypes.string,
  cta: PropTypes.func.isRequired,
};

const Container = styled.div`
  margin: 0 auto;
  max-width: 940px;
  padding: 0 15px;
`;

const Card = styled.div`
  background-color: ${theme.colorWhite};
  box-shadow: ${theme.boxShadowCard};
  display: flex;
  align-items: stretch;
`;

const GraphicOuterWrapper = styled.div`
  width: 288px;
  flex-shrink: 0;
  position: relative;
  display: none;

  @media (min-width: ${theme.breakpointMd}) {
    display: block;
  }
`;

// The inner and outer wrapper essentially make the graphic act
// similar to a background-image with background-position: cover
const GraphicInnerWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${theme.spacingXl};

  @media (min-width: ${theme.breakpointMd}) {
    padding: ${theme.spacingXxl};
  }

  ${(p) =>
    p.hasGraphic &&
    `@media (min-width: ${theme.breakpointMd}) {
      align-items: flex-start;
      text-align: left;
    }`};
`;

const H3 = styled.h3`
  font-family: ${theme.fontFamilyPrimary};
  font-size: ${theme.fontSizeH3};
  font-weight: ${theme.fontWeightBold};
  color: ${theme.colorBase};
  margin: 0;
`;

const Body = styled.div`
  font-family: ${theme.fontFamilyPrimary};
  font-size: ${theme.fontSizeSm};
  font-weight: ${theme.fontWeightNormal};
  color: ${theme.colorBase};
  margin: ${rems(12)} 0 0;

  @media (min-width: ${theme.breakpointMd}) {
    font-size: ${theme.fontSizeBase};
  }
`;

const Cta = styled.div`
  margin: ${rems(18)} 0 0;
`;

const CtaCard = ({ graphic, heading, body, cta }) => (
  <Container>
    <Card>
      {graphic && (
        <GraphicOuterWrapper>
          <GraphicInnerWrapper>{graphic()}</GraphicInnerWrapper>
        </GraphicOuterWrapper>
      )}
      <Content hasGraphic={!!graphic}>
        <H3>{heading}</H3>
        {body && body !== '' && <Body>{body}</Body>}
        <Cta>{cta()}</Cta>
      </Content>
    </Card>
  </Container>
);

CtaCard.propTypes = PROP_TYPES;
CtaCard.displayName = 'CtaCard';

export default CtaCard;
